import { Link } from 'react-router-dom';
import { ChevronRight, MapPin } from 'lucide-react';
import { Employee } from '../types/employee';

interface EmployeeListProps {
  employees: Employee[];
}

const EmployeeList = ({ employees }: EmployeeListProps) => {
  const employeesByDepartment = employees.reduce((acc, employee) => {
    const department = employee.department;
    if (!acc[department]) acc[department] = [];
    acc[department].push(employee);
    return acc;
  }, {} as Record<string, Employee[]>);

  const sortedDepartments = Object.keys(employeesByDepartment).sort();

  return (
    <div className="space-y-4 animate-fade-in">
      {sortedDepartments.map(department => (
        <div key={department} className="card overflow-hidden">
          {/* Department header */}
          <div className="px-5 py-3 border-b border-bolt-border flex items-center justify-between">
            <div>
              <h2 className="text-sm font-semibold text-bolt-text">{department}</h2>
            </div>
            <span className="text-xs text-bolt-textSubtle bg-bolt-bg border border-bolt-border px-2 py-0.5 rounded-full">
              {employeesByDepartment[department].length} {employeesByDepartment[department].length === 1 ? 'member' : 'members'}
            </span>
          </div>

          <ul className="">
            {employeesByDepartment[department].map(employee => (
              <li key={employee.id} class="border-b border-bolt-border">
                <Link
                  to={`/employee/${employee.id}`}
                  className="px-5 py-3.5 flex items-center gap-4 hover:bg-bolt-surfaceHover transition-colors group"
                >
                  <img
                    src={employee.avatar}
                    alt={employee.name}
                    className="w-9 h-9 rounded-full object-cover object-center border-2 border-bolt-border flex-shrink-0"
                  />

                  <div className="flex-grow min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <span className="text-sm font-medium text-bolt-text truncate group-hover:text-primary-300 transition-colors">
                        {employee.name}
                      </span>
                      <ChevronRight className="h-4 w-4 text-bolt-textSubtle flex-shrink-0 group-hover:text-primary-400 transition-colors" />
                    </div>
                    <p className="text-xs text-bolt-textMuted truncate">{employee.role}</p>
                    <div className="mt-0.5 flex items-center gap-1 text-xs text-bolt-textSubtle">
                      <MapPin className="h-3 w-3 flex-shrink-0" />
                      <span className="truncate">
                        {[employee.location.city, employee.location.country].filter(Boolean).join(', ')}
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default EmployeeList;
